import React, { Fragment } from 'react';

function Footer () {
  let at = new Date();
  let year = at.getFullYear();
  return (
    <Fragment>
      <div className='foot'> 
        <div className='center960 border footer'>
          <span>友情链接：友情链接：友情链接：友情链接：友情链接：友情链接</span>
          <span>Copyright ©2003-{year} 青岛利凯达网络科技有限公司</span>
          <span>www.qdlkd.com All Rights Reserved.</span>
          <span>电话: 0532-68988036 邮箱: qdlkd2009@126.com</span>
          <span>备案号: 鲁ICP备11010262号</span>
        </div>
      </div>
    </Fragment>
  )
}

export default Footer
